import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
export default function ImagePreview({
  src,
  alt,
  className = '',
  children
}) {
  const {
    t
  } = useTranslation();
  const [open, setOpen] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  function close() {
    setOpen(false);
    setZoomed(false);
  }
  return <>
      <button type="button" className={`image-preview-trigger ${className}`} aria-label={t("enlarge", {
      value: alt
    })} aria-haspopup="dialog" onClick={() => setOpen(true)}>
        <img src={src} alt={alt} loading="lazy" />
        {children || <span className="image-preview-hint">{t("enlarge_detail")} <span aria-hidden="true">⤢</span></span>}
      </button>
      <Dialog open={open} onClose={close} className="image-preview-dialog">
        <div className="image-preview-backdrop" aria-hidden="true" />
        <div className="image-preview-position">
          <DialogPanel className="image-preview-panel">
            <div className="image-preview-toolbar">
              <DialogTitle className="image-preview-title">{alt}</DialogTitle>
              <div className="image-preview-controls">
                <button type="button" aria-pressed={zoomed} onClick={() => setZoomed(!zoomed)}>
                  {zoomed ? t("fit_to_screen") : 'Zoom +'}
                </button>
                <button type="button" onClick={close} aria-label={t("close_image_preview")} data-autofocus> {t("close")} <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
            <div className={`image-preview-viewport${zoomed ? ' is-zoomed' : ''}`} tabIndex={zoomed ? 0 : undefined} aria-label={zoomed ? t("enlarged_image_scroll_to_explore_the_details") : undefined}>
              <img src={src} alt={alt} className="image-preview-full" />
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>;
}
